import React from "react";
import { useSelector } from "react-redux";
import ProductItem from "./ProductItem";

export default function Products() {
  const { products } = useSelector((state) => state.product);

  let content = null;
  if (products.length > 0) {
    content = products.map((product) => (
      <ProductItem key={product.product_id} product={product} />
    ));
  } else if (products.length === 0) {
    content = <h3>No Product Found.</h3>;
  }

  return (
    <div className="productContainer" id="lws-productContainer">
      {content}
    </div>
  );
}
